import { Languages } from 'lucide-react';
import { useLang, useT, LANGS, type Lang } from '../i18n';
import { cn } from '../lib/cn';

const LABELS: Record<Lang, string> = { uz: "O'zbekcha", ru: 'Русский' };
const SHORT: Record<Lang, string> = { uz: 'UZ', ru: 'RU' };

/**
 * Переключатель языка админки. Выбор хранится в localStorage, по умолчанию —
 * узбекский. На язык бота не влияет (там `BOT_LOCALE` в backend/.env).
 */
export function LangSwitcher({ compact = false }: { compact?: boolean }) {
  const { lang, setLang } = useLang();
  const t = useT();

  if (compact) {
    return (
      <div
        className="inline-flex overflow-hidden rounded-md border border-slate-300"
        role="group"
        aria-label={t('lang.switchLabel')}
      >
        {LANGS.map((code) => (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-pressed={lang === code}
            title={LABELS[code]}
            className={cn(
              'px-2 py-1 text-xs font-medium transition-colors',
              lang === code
                ? 'bg-slate-900 text-white'
                : 'bg-white text-slate-600 hover:bg-slate-50',
            )}
          >
            {SHORT[code]}
          </button>
        ))}
      </div>
    );
  }

  return (
    <label className="inline-flex items-center gap-2 text-sm text-slate-600">
      <Languages className="h-4 w-4 text-slate-400" />
      <span className="sr-only">{t('lang.switchLabel')}</span>
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value as Lang)}
        className="h-9 rounded-md border border-slate-300 bg-white px-2 text-sm"
      >
        {LANGS.map((code) => (
          <option key={code} value={code}>
            {LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
